module.exports = __webpack_public_path__ + "img/software-banner.abae0ae4.svg";